import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'semantic-ui-react';
import {
  TIME_CONDITION_OPTIONS,
  TIME_PERIOD_OPTIONS,
  TIMEZONE_OPTIONS,
} from '../fieldsConfig';

// Generate hour options (1-12 for 12-hour format)
const HOUR_OPTIONS = Array.from({ length: 12 }, (_, i) => ({
  key: i + 1,
  text: String(i + 1),
  value: i + 1,
}));

// Generate minute options (0-59)
const MINUTE_OPTIONS = Array.from({ length: 60 }, (_, i) => ({
  key: i,
  text: String(i).padStart(2, '0'),
  value: i,
}));

const TimePicker = ({
  rule, onValueChange, disabled, allowAddCondition,
}) => (
  <div className='time-picker'>
    <Dropdown
      selection
      options={TIME_CONDITION_OPTIONS}
      value={rule.timeCondition}
      onChange={(e, data) => onValueChange(rule.instanceId, 'timeCondition', data.value)}
      disabled={disabled}
    />
    <Dropdown
      selection
      options={HOUR_OPTIONS}
      value={rule.timeHour}
      onChange={(e, data) => onValueChange(rule.instanceId, 'timeHour', data.value)}
      disabled={disabled}
      placeholder='HH'
    />
    <Dropdown
      selection
      options={MINUTE_OPTIONS}
      value={rule.timeMinute}
      onChange={(e, data) => onValueChange(rule.instanceId, 'timeMinute', data.value)}
      disabled={disabled}
      placeholder='MM'
    />
    <Dropdown
      selection
      options={TIME_PERIOD_OPTIONS}
      value={rule.timePeriod}
      onChange={(e, data) => onValueChange(rule.instanceId, 'timePeriod', data.value)}
      disabled={disabled}
    />
    <Dropdown
      selection
      options={TIMEZONE_OPTIONS}
      value={rule.timeZone}
      onChange={(e, data) => onValueChange(rule.instanceId, 'timeZone', data.value)}
      disabled={disabled}
    />
    {allowAddCondition && (
      <a href='#' className='add-condition-link'>
        + Add condition
      </a>
    )}
  </div>
);

TimePicker.propTypes = {
  rule: PropTypes.object.isRequired,
  onValueChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  allowAddCondition: PropTypes.bool,
};

export default TimePicker;
